export default "__VITE_ASSET__Dyw2Zvg4__"